import { render, staticRenderFns } from "./labelLayout.vue?vue&type=template&id=52094556&scoped=true&"
import script from "./labelLayout.vue?vue&type=script&lang=js&"
export * from "./labelLayout.vue?vue&type=script&lang=js&"
import style0 from "./labelLayout.vue?vue&type=style&index=0&id=52094556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52094556",
  null
  
)

export default component.exports